import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Products from "./Products";
import OfferBanner from "./OfferBanner";
import FeaturedPaintings from "./FeaturedPaintings";
import { Link } from "react-router-dom";
import { useContext } from "react";
import { Context } from "../../Context/ContextApi";

const HomePage = () => {
  // 1. Slider settings remain good for a primary carousel
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    arrows: false,
    lazyLoad: 'ondemand',
  };

  const { slide, category } = useContext(Context);
  // Renamed featuredPaintings to avoid unused variable warning, but you can keep it if used elsewhere.

  const sliderData = slide?.data?.slider;
  const categoryData = category?.data?.data;

  // Add a simple check for loading state (improves perceived performance)
  if (!sliderData || !categoryData) {
    // You can replace this with a proper Skeleton UI for better user experience
    return <div className="loading-state">Loading art gallery...</div>;
  }

  return (
    <>
      <div className="home-page-slider">

        {/* === Primary Slider Section === */}
        <Slider {...settings}>
          {sliderData.map((item, index) => (
            <div key={item.id} className="slider-item">
              <Link to="/shop">
                <div className="slider-content">
                  <img
                    // 🚀 IMPROVEMENT: Use 'data-src' instead of 'src' for lazy loading
                    // Only the first slide will use 'src' if lazyLoad is 'ondemand' and the rest will use 'data-src'.
                    // The first image (index === 0) loads instantly, and slick handles the rest.
                    data-src={`https://admin.tulikaarts.in/${item?.slider_image}`}
                    alt={item.slider_name}
                    className="slick-image-placeholder" // Optional: Add a class for styling a placeholder/spinner
                  />
                </div>
              </Link>
            </div>
          ))}
        </Slider>

        {/* === Features/Benefits Section === */}
        <section className="mt-5 mb-5">
          <div className="container">
            <div className="row">
              <div className="col-md-4 mt-3">
                <div className="second-section-cols">
                  {/* Consistent use of className for all icons (using 'fa fa-truck') */}
                  <i className="fa fa-truck" aria-hidden="true"></i>
                  <div>
                    <h6>Fast Delivery</h6>
                    <p>Within 15 Days</p>
                  </div>
                </div>
              </div>
              <div className="col-md-4 mt-3">
                <div className="second-section-cols">
                  {/* Cleaned up inline style and inconsistent class usage */}
                  <i className="fa fa-shield" aria-hidden="true"></i>
                  <div>
                    <h6>Secured</h6>
                    <p>Checkout and Payments</p>
                  </div>
                </div>
              </div>
              <div className="col-md-4 mt-3">
                <div className="second-section-cols">
                  {/* Corrected class and removed unnecessary inline style. Use CSS for styling. */}
                  <i className="fa fa-hand-o-up" aria-hidden="true"></i>
                  <div>
                    <h6>Genuine Paintings</h6>
                    <p>Handmade with love</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* === Category Gallery Section (Performance Improvement Applied Here) === */}
        
        <div className="container our-category">
          <h1>Our Painting Gallery</h1>

          <div className="row">
            {categoryData.map((item) => {
              return (
                <div key={item.id} className="col-md-3 mb-4">
                  <Link to={`/shop/${item?.category_url}`}>
                    <div className="item text-center">

                      {/* 🚀 New Wrapper for Circular Image */}
                      <div className="circular-img-wrapper">
                        <img
                          src={`https://admin.tulikaarts.in/${item?.category_image}`}
                          alt={item.category_name}
                          loading="lazy"
                          className="category-circle-img" // 🎯 New class for styling
                        />
                      </div>

                      <h2>{item?.category_name}</h2>
                    </div>
                  </Link>
                </div>
              );
            })}
          </div>
        </div>

        {/* === Additional Components === */}
        <div>
          <Products />
        </div>
        <div>
          <OfferBanner />
        </div>
        <div>
          <FeaturedPaintings />
        </div>
      </div>
    </>
  );
};

export default HomePage;